<mat-stepper
  #stepper
  [linear]="linear"
  class="mosaiku-stepper"
  [orientation]="orientation"
  [labelPosition]="labelPosition"
  (selectionChange)="selectionChange.emit($event)"
>
  <ng-template matStepperIcon="edit">
    <mat-icon>{{ editIcon }}</mat-icon>
  </ng-template>

  <mat-step
    *ngFor="let step of steps; let i = index; trackBy: trackByIndex"
    [stepControl]="step.stepControl!"
    [label]="step.label"
    [completed]="step.completed"
    [optional]="step.optional"
    [editable]="step.editable"
  >
    <ng-container
      *ngTemplateOutlet="
        step.templateRef;
        context: { $implicit: stepper, stepper: stepper, index: i }
      "
    ></ng-container>
  </mat-step>
</mat-stepper>
